var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubArrow = function SvgSubArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.99992L6 8.99992L5.05333 8.05325L7.44667 5.66659H0L0 0H1.33333V4.33325H7.44667L5.05333 1.94659L6 0.999919L10 4.99992Z",
    fill: "#33445E"
  })));
};
export default SvgSubArrow;